/**
 * owner_resident_status values of the Users > Pending list. The tenant dashboard counts "pending requests"
 * with the same list, so the number on the tile is the length of that tab.
 */
export const PENDING_USER_STATUSES = [
  'denied',
  'processing',
  'escalated',
  'waiting_for_customer',
  'flagged',
  'disabled',
] as const;

/** user_type ids shown in Users > Pending: 2 = Owner, 3 = Resident. */
export const PENDING_USER_TYPES = ['2', '3'] as const;
